import type { TunaPlugin } from '@tunasong/plugin-lib'

export const canConfigureEntity = (plugin?: TunaPlugin) => Boolean(plugin?.schema || plugin?.components?.CreateEntity)
